export const getIpPublic = async () =>{
    const publicIp = require('public-ip');
    let ip = await publicIp.v4({
        fallbackUrls: [
            'https://ifconfig.co/ip'
        ]
    });
    return ip;
}